import { CSSProperties } from 'react';
import { theme } from '../../theme';

const button: CSSProperties = {
  width: '100%',
  padding: '12px 16px',
  borderRadius: theme.radius.sm,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.fontSize.base,
  fontWeight: theme.typography.fontWeight.bold,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing.small,
};

export const sessionExpiredStyles = {
  container: {
    minHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.medium,
    padding: `${theme.spacing.large}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.white,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'center',
  } as CSSProperties,

  title: {
    margin: 0,
    fontSize: theme.typography.fontSize.xl,
    lineHeight: '32px',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.palette.blue150,
  } as CSSProperties,

  message: {
    margin: 0,
    maxWidth: 360,
    whiteSpace: 'pre-line',
    fontSize: theme.typography.fontSize.base,
    lineHeight: '24px',
    color: theme.colors.label,
  } as CSSProperties,

  actions: {
    width: '100%',
    maxWidth: 320,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.small,
    marginTop: theme.spacing.small,
  } as CSSProperties,

  primaryButton: {
    ...button,
    border: 'none',
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
  } as CSSProperties,

  secondaryButton: {
    ...button,
    border: `1px solid ${theme.colors.button.primary}`,
    backgroundColor: theme.colors.white,
    color: theme.colors.button.primary,
  } as CSSProperties,

  help: {
    width: '100%',
    maxWidth: 320,
    marginTop: theme.spacing.small,
    paddingTop: theme.spacing.medium,
    borderTop: `1px solid ${theme.colors.palette.grey200}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.extraSmall,
  } as CSSProperties,

  helpQuestion: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.small,
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.label,
  } as CSSProperties,

  helpIcon: {
    width: 18,
    height: 18,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.colors.label}`,
    borderRadius: '50%',
    fontSize: 11,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  helpLink: {
    padding: 0,
    border: 'none',
    background: 'none',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.xs,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.button.primary,
    cursor: 'pointer',
  } as CSSProperties,
};
